import {
    AttachRegular,
    MentionRegular,
    LinkRegular,
    ClockRegular,
    ArrowReplyRegular,
    ArrowForwardRegular,
    LockClosedRegular,
    VoicemailRegular,
    CalendarEmptyRegular,
    CalendarCheckmarkRegular,
    CalendarCancelRegular,
    CalendarQuestionMarkRegular,
    CalendarEyeRegular,
    CalendarPersonRegular,
    CheckboxCheckedRegular,
    CalendarSyncRegular,
    NotepadRegular,
    NoteRegular,
    ArrowCircleRightRegular,
    DoorArrowLeftRegular,
    CheckmarkCircleRegular,
    MailDismissRegular,
    PinFilled,
    FlagFilled,
    CheckmarkRegular,
    ClockAlarmRegular,
    ArrowDownRegular,
    ImportantRegular,
    RibbonRegular,
} from '@fluentui/react-icons';
import PropertyIcons from './PropertyIcons';
import type { JSX } from 'react';

export function getPropertyIconFromNameKey(
    propertyIcon: PropertyIcons,
    className?: string
): JSX.Element | undefined {
    let icon: JSX.Element | undefined = undefined;

    switch (propertyIcon) {
        case PropertyIcons.GlobalMentionedMe:
            icon = <MentionRegular className={className} />;
            break;
        case PropertyIcons.Attachment:
            icon = <AttachRegular className={className} />;
            break;
        case PropertyIcons.ImportanceLow:
            icon = <ArrowDownRegular className={className} />;
            break;
        case PropertyIcons.ImportanceHigh:
            icon = <ImportantRegular className={className} />;
            break;
        case PropertyIcons.Snooze:
            icon = <ClockRegular className={className} />;
            break;
        case PropertyIcons.MailListViewReplied:
            icon = <ArrowReplyRegular className={className} />;
            break;
        case PropertyIcons.MailListViewForwarded:
            icon = <ArrowForwardRegular className={className} />;
            break;
        case PropertyIcons.LockClosedRegular:
            icon = <LockClosedRegular className={className} />;
            break;
        case PropertyIcons.RibbonRegular:
            icon = <RibbonRegular className={className} />;
            break;
        case PropertyIcons.MailListViewIRM:
        case PropertyIcons.MailListViewIRMReplied:
        case PropertyIcons.MailListViewIRMForwarded:
            icon = <LockClosedRegular className={className} />;
            break;
        case PropertyIcons.MailListViewVoiceMailItem:
            icon = <VoicemailRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentItem:
            icon = <CalendarEmptyRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentDelegate:
            icon = <CalendarPersonRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentAccepted:
            icon = <CalendarCheckmarkRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentDeclined:
            icon = <CalendarCancelRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentTentative:
            icon = <CalendarQuestionMarkRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentFollow:
            icon = <CalendarEyeRegular className={className} />;
            break;
        case PropertyIcons.MailListViewAppointmentCanceled:
            icon = <CalendarCancelRegular className={className} />;
            break;
        case PropertyIcons.MailListViewTaskItem:
            icon = <CheckboxCheckedRegular className={className} />;
            break;
        case PropertyIcons.MailListViewTaskReocurItem:
            icon = <CalendarSyncRegular className={className} />;
            break;
        case PropertyIcons.MailListViewJournalItem:
            icon = <NotepadRegular className={className} />;
            break;
        case PropertyIcons.MailListViewNoteItem:
            icon = <NoteRegular className={className} />;
            break;
        case PropertyIcons.MailListViewDelivery:
            icon = <ArrowCircleRightRegular className={className} />;
            break;
        case PropertyIcons.MailListViewOutOfOffice:
            icon = <DoorArrowLeftRegular className={className} />;
            break;
        case PropertyIcons.MailListViewReadReport:
            icon = <CheckmarkCircleRegular className={className} />;
            break;
        case PropertyIcons.Link:
            icon = <LinkRegular className={className} />;
            break;
        case PropertyIcons.MailDismiss:
            icon = <MailDismissRegular className={className} />;
            break;
        case PropertyIcons.Pinned:
            icon = <PinFilled className={className} />;
            break;
        case PropertyIcons.Flagged:
            icon = <FlagFilled className={className} />;
            break;
        case PropertyIcons.Completed:
            icon = <CheckmarkRegular className={className} />;
            break;
        case PropertyIcons.Reminder:
            icon = <ClockAlarmRegular className={className} />;
            break;
        case PropertyIcons.None:
            icon = <span className={className} />;
            break;
        default:
            icon = undefined;
            break;
    }

    return icon;
}
